import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: 'AIzaSyD5Ox9-JiGGaLKAW1cfWDJtSyMT27MiG70',
    authDomain: 'kks-project-b7531.firebaseapp.com',
    projectId: 'kks-project-b7531',
    storageBucket: 'kks-project-b7531.appspot.com',
    messagingSenderId: '538623761434',
    appId: '1:538623761434:web:e5de892443ca0eb0f805a3',
    measurementId: 'G-Y1SDBDVSL2',
};

// Firebase configuration with env 
// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_API_KEY,
//     authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_APP_ID,
//     measurementId: process.env.REACT_APP_MEASUREMENT_ID,
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);